const kebab = (s) => String(s || "").toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "").replace(/[^a-z0-9]+/g, "-").replace(/^-+|-+$/g, "");

// Conteneur de section premium (formulaires, paramètres, sous-tableaux) — KAIZEN SYSTEM.
export function SectionCard({ title, description, headerActions, icon: Icon, children, noPadding = false, className = "" }) {
  return (
    <div
      data-testid={`section-card-${kebab(title) || "section"}`}
      className={`rounded-xl bg-zinc-900 border border-zinc-800 flex flex-col w-full shadow-sm ${className}`}
    >
      {(title || headerActions) && (
        <div className="px-6 py-5 border-b border-zinc-800/80 flex justify-between items-center gap-4 bg-zinc-900/50 rounded-t-xl">
          <div className="flex items-center gap-3 min-w-0">
            {Icon && <Icon size={20} weight="duotone" className="text-amber-500 shrink-0" />}
            <div className="min-w-0">
              {title && <h2 className="text-lg font-semibold font-cabinet text-zinc-50 truncate">{title}</h2>}
              {description && <p className="text-xs text-zinc-400 font-manrope mt-0.5">{description}</p>}
            </div>
          </div>
          {headerActions && <div className="flex items-center gap-2 shrink-0">{headerActions}</div>}
        </div>
      )}
      <div className={noPadding ? "" : "p-6 flex flex-col gap-6"}>{children}</div>
    </div>
  );
}

export default SectionCard;
